import constants from '../constants.js';

const PerDiemManager = {
  rootNode: true,
  displayName: 'Per Diem',
  iconClass: 'fa-pin',
  displayAs: constants.DISPLAY_AS.PER_DIEM
};

const PerDiemGridItem = {
  displayName: 'Per Diem Grid Item',
  iconClass: 'fa-pin',
  displayAs: constants.DISPLAY_AS.PER_DIEM_GRID_ITEM
};

const PerDiemFileUploader = {
  rootNode: true,
  displayName: 'Per Diem File Uploader',
  iconClass: 'fa-pin',
  displayAs: constants.DISPLAY_AS.PER_DIEM_FILE_UPLOADER
}

export default {
  PerDiemManager,
  PerDiemGridItem,
  PerDiemFileUploader
}


// WEBPACK FOOTER //
// ./src/config/fields/perDiem.js